/* cn-video-play.js — shared click-to-play behavior.
   Contract:
     [data-cn-video-group]            root; one per section instance
       [data-cn-video-play]           a card; a click anywhere on it plays
         data-cn-video-embed          iframe URL (YouTube/Vimeo) — wins if present
         data-cn-video-src            direct video file URL (Shopify-hosted mp4)
         data-cn-video-title          accessible title for the player
   State set by this module (style it, do not guess it):
     card[data-cn-video-state="playing"]   while its player is mounted
     player[data-cn-video-media]           the <video>/<iframe> appended to the card
   Starting one card stops every other card in the same group. A finished
   video, or leaving the tab, returns cards to their poster / paused state. */
(function () {
  'use strict';

  function pause(card) {
    var media = card.querySelector('[data-cn-video-media]');
    if (!media) return;
    if (media.tagName === 'VIDEO') {
      media.pause();
      return;
    }
    var src = media.getAttribute('src') || '';
    var msg = null;
    if (src.indexOf('youtube.com') !== -1) msg = JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] });
    if (src.indexOf('vimeo.com') !== -1) msg = JSON.stringify({ method: 'pause' });
    if (msg && media.contentWindow) media.contentWindow.postMessage(msg, '*');
  }

  function stop(card) {
    var media = card.querySelector('[data-cn-video-media]');
    if (media) {
      if (media.tagName === 'VIDEO') media.pause();
      media.parentNode.removeChild(media);
    }
    card.removeAttribute('data-cn-video-state');
  }

  function play(card, group) {
    if (card.getAttribute('data-cn-video-state') === 'playing') return;

    Array.prototype.forEach.call(group.querySelectorAll('[data-cn-video-state="playing"]'), function (other) {
      if (other !== card) stop(other);
    });

    var embed = card.getAttribute('data-cn-video-embed');
    var src = card.getAttribute('data-cn-video-src');
    var title = card.getAttribute('data-cn-video-title') || 'Video';
    var media;

    if (embed) {
      media = document.createElement('iframe');
      media.src = embed;
      media.title = title;
      media.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      media.allowFullscreen = true;
    } else if (src) {
      media = document.createElement('video');
      media.src = src;
      media.controls = true;
      media.autoplay = true;
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      media.setAttribute('aria-label', title);
      media.addEventListener('ended', function () {
        stop(card);
      });
    } else {
      return;
    }

    media.setAttribute('data-cn-video-media', '');
    card.appendChild(media);
    card.setAttribute('data-cn-video-state', 'playing');

    if (media.tagName === 'VIDEO') {
      var started = media.play();
      if (started && typeof started.catch === 'function') started.catch(function () {});
      media.focus();
    }
  }

  function init(group) {
    if (group.__cnVideoPlay) return;

    function onClick(e) {
      var card = e.target.closest('[data-cn-video-play]');
      if (!card || !group.contains(card)) return;
      if (e.target.closest('[data-cn-video-media]')) return;
      play(card, group);
    }

    function onVisibility() {
      if (!document.hidden) return;
      Array.prototype.forEach.call(group.querySelectorAll('[data-cn-video-state="playing"]'), pause);
    }

    group.addEventListener('click', onClick);
    document.addEventListener('visibilitychange', onVisibility);

    group.__cnVideoPlay = {
      destroy: function () {
        group.removeEventListener('click', onClick);
        document.removeEventListener('visibilitychange', onVisibility);
        Array.prototype.forEach.call(group.querySelectorAll('[data-cn-video-play]'), stop);
        delete group.__cnVideoPlay;
      }
    };
  }

  function initAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cn-video-group]'), init);
  }

  function destroyAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cn-video-group]'), function (group) {
      if (group.__cnVideoPlay) group.__cnVideoPlay.destroy();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroyAll(e.target);
  });
})();
